// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const evidenceArtefactSchema = z.object({
  "filename": z.string(),
  "title": z.string(),
  "description": z.string(),
  "content_type": z.string(),
  "sha256": z.string(),
  "id": z.string().uuid(),
  "size_bytes": z.number().int().min(0),
  "uploaded_at": z.string().datetime({ offset: true }),
  "uploaded_by": z.string().uuid().nullable().optional(),
  "uploaded_by_email": z.string().default(""),
  "retention_until": z.string().datetime({ offset: true }).nullable().optional(),
  "sensitivity": z.enum(["public_safe", "auditor_only", "internal_only"]),
  "covers_from": z.string().default(""),
  "covers_to": z.string().default("")
});

export const evidenceListResponseSchema = z.object({
  "data": z.array(evidenceArtefactSchema)
});

export const evidenceMetadataUpdateSchema = z.object({
  "title": z.string().max(200).optional(),
  "description": z.string().max(4000).optional(),
  "retention_until": z.string().datetime({ offset: true }).optional(),
  "covers_from": z.string().regex(new RegExp("^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?$")).optional(),
  "covers_to": z.string().regex(new RegExp("^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?$")).optional(),
  "expected_covers_from": z.string().regex(new RegExp("^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?$")).optional(),
  "expected_covers_to": z.string().regex(new RegExp("^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?$")).optional()
});

export const evidenceLinkCreateSchema = z.object({
  "catalog_id": z.string().uuid(),
  "note": z.string().optional()
});

export const evidenceSensitivitySchema = z.object({
  "sensitivity": z.enum(["auditor_only", "public_safe", "internal_only"])
}).strict();
